import moment from 'moment';

const EXPIRY_API_FORMAT = 'MM-YY';
const EXPIRY_DOMAIN_FORMAT = 'MM/YYYY';

const EXPIRY_FORMATS = [EXPIRY_API_FORMAT, EXPIRY_DOMAIN_FORMAT];

export const isPaymentMethodExpired = (date: string) => {
  return moment(date, EXPIRY_FORMATS).isBefore(moment().startOf('month'));
};

export const isPaymentMethodExpiringWithinMonths = (
  date: string,
  monthOffset: number,
) => {
  const expiry = moment(date, EXPIRY_FORMATS);
  const targetMonth = moment().add(monthOffset, 'months').endOf('month');
  return (
    !isPaymentMethodExpired(date) && expiry.isSameOrBefore(targetMonth, 'month')
  );
};

export const formatExpiryForDisplay = (expiry: string) => {
  return moment(expiry, EXPIRY_API_FORMAT).format(EXPIRY_DOMAIN_FORMAT);
};
